import { gql } from '@/utilities/gql';
import type { FragmentOf } from '@/utilities/gql';

export const NARRATIVE_UPDATE_PANEL_FRAGMENT = gql(`
  fragment NarrativeUpdatePanelFields on NarrativeUpdate @_unmask {
    id
    position
    publishedAt
    excerpt
    slug
    valuation {
      fairValue
    }
    prev {
      valuation {
        fairValue
      }
    }
    narrative {
      company {
        canonicalCommunityUrl
      }
      slug
    }
  }
`);

export type NarrativeUpdate = FragmentOf<
  typeof NARRATIVE_UPDATE_PANEL_FRAGMENT
>;
